import { useLocation } from 'react-router-dom';

import { cageScopedSearch } from './params';

/**
 * The current URL's cage-scoped params (`fg`, daypart, unit), re-serialised: append it to a link
 * or redirect to another page of the same pen, so that page answers for the same fish group.
 * `''` when there are none.
 */
export function useCageScopedSearch(): string {
    return cageScopedSearch(useLocation().search);
}
